import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const getValidationSchema = (t: TFunction) =>
    Yup.object().shape({
        amount: Yup.string()
            .required(t('Event:errors:amount_required'))
            .matches(/^\d+$/, t('Event:errors:amount_invalid'))
            .test(
                'is below max amount',
                t('Event:errors:amount_max'),
                (value) => {
                    if (!value) return false;

                    return Number(value) <= 1000;
                },
            )
            .test('is min amount', t('Event:errors:amount_min'), (value) => {
                if (!value) return false;

                return Number(value) >= 1;
            }),
    });
